module.exports = __webpack_public_path__ + "static/media/gp.85d61cca.png";